import React from 'react';
import { PropTypes } from 'prop-types';
import ReadOnlyRichTextEditor from 'common/components/RichTextEditor/ReadOnlyRichTextEditor';
import { useJunctionErrorMapping } from 'common/helpers/useJunctionErrorMapping';
import { sanitize } from 'common/services/sanitizeService';
import { junctionColorMapping } from 'common/helpers/junctionColorMapping';

const NonEditableTextEditor = ({ projectId, richTextData, childrenData }) => {
  // todo -> this fix is only temporary until BE dont have time to fix error content
  const mappedRichTextData = useJunctionErrorMapping(richTextData, projectId);

  // Shared rich text library items have their child items already pre-rendered and embedded into the richTextData html markup.
  // CKEditor does not like embedded svgs and charts so this was a work-around
  const useCKEditor = childrenData.length > 0;
  return !useCKEditor ? (
    <div
      data-testid="description-with-innerhtml"
      className="description-body rich-text-content-item-container css-override"
      dangerouslySetInnerHTML={{
        __html: sanitize(junctionColorMapping(mappedRichTextData)),
      }}
    />
  ) : (
    <div className="description-body css-override">
      <ReadOnlyRichTextEditor
        projectId={projectId}
        richTextData={mappedRichTextData}
        childrenData={childrenData}
      />
    </div>
  );
};

NonEditableTextEditor.propTypes = {
  richTextData: PropTypes.string,
  childrenData: PropTypes.arrayOf(PropTypes.shape({})),
};

NonEditableTextEditor.defaultProps = {
  richTextData: '',
  childrenData: [],
};

export default NonEditableTextEditor;
